import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=b10ec182&scoped=true&lang=pug&"
import script from "./IconBase.vue?vue&type=script&lang=js&"
export * from "./IconBase.vue?vue&type=script&lang=js&"
import style0 from "./IconBase.vue?vue&type=style&index=0&id=b10ec182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10ec182",
  null
  
)

export default component.exports